var chunkMapping = {
	"src_bootstrap_tsx": [
		"webpack/container/remote/ApplicationDatasetRemote/ApiToken",
		"webpack/container/remote/ApplicationFrameRemote/AccessToken",
		"webpack/container/remote/ApplicationJobsRemote/ApiToken",
		"webpack/container/remote/ApplicationModelConfigRemote/ApiToken",
		"webpack/container/remote/ApplicationProjectsRemote/ApiToken",
		"webpack/container/remote/ApplicationReportRemote/ApiToken",
		"webpack/container/remote/StyleManagementRemote/StyleLoader",
		"webpack/container/remote/StyleManagementRemote/StyleSelect",
		"webpack/container/remote/ApplicationFrameRemote/ConfigData",
		"webpack/container/remote/ApplicationFrameRemote/Menu",
		"webpack/container/remote/ApplicationFrameRemote/AccessSignInButton",
		"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorDataset",
		"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorGeodata",
		"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorHoT",
		"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorLabels",
		"webpack/container/remote/ApplicationMapRemote/ScenarioEditorMap",
		"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorSpecification",
		"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorToolbar",
		"webpack/container/remote/ApplicationJobsRemote/DataExperiment",
		"webpack/container/remote/ApplicationModelConfigRemote/DataScenario",
		"webpack/container/remote/ApplicationProjectsRemote/DataProjectList",
		"webpack/container/remote/ApplicationModelConfigRemote/ScenarioList",
		"webpack/container/remote/ApplicationProjectsRemote/ProjectSelector",
		"webpack/container/remote/ApplicationProjectsRemote/DataProject",
		"webpack/container/remote/ApplicationJobsRemote/ExperimentFactory",
		"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorForm",
		"webpack/container/remote/ApplicationJobsRemote/EventNotifier",
		"webpack/container/remote/ApplicationJobsRemote/ExperimentStatusDetail",
		"webpack/container/remote/ApplicationModelConfigRemote/ScenarioHooks",
		"webpack/container/remote/ApplicationProjectsRemote/ProjectFactory",
		"webpack/container/remote/ApplicationReportRemote/ReportHooks",
		"webpack/container/remote/ApplicationReportRemote/ReportView",
		"webpack/container/remote/ApplicationJobsRemote/ExperimentsView",
		"webpack/container/remote/ApplicationModelConfigRemote/ScenarioForm",
		"webpack/container/remote/ApplicationModelConfigRemote/DataScenarioContexts",
		"webpack/container/remote/ApplicationProjectsRemote/ProjectList",
		"webpack/container/remote/ApplicationProjectsRemote/ProjectForm",
		"webpack/container/remote/ApplicationJobsRemote/ExperimentProgressBar",
		"webpack/container/remote/ApplicationJobsRemote/ExperimentStartControl",
		"webpack/container/remote/ApplicationJobsRemote/ExperimentStopControl"
	],
	"webpack_container_remote_ApplicationProjectsRemote_ProjectTagSettings": [
		"webpack/container/remote/ApplicationProjectsRemote/ProjectTagSettings"
	],
	"webpack_container_remote_ApplicationModelConfigRemote_ScenarioTagSettings": [
		"webpack/container/remote/ApplicationModelConfigRemote/ScenarioTagSettings"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/ApplicationDatasetRemote/ApiToken": [
		"default",
		"./ApiToken",
		"webpack/container/reference/ApplicationDatasetRemote"
	],
	"webpack/container/remote/ApplicationFrameRemote/AccessToken": [
		"default",
		"./AccessToken",
		"webpack/container/reference/ApplicationFrameRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/ApiToken": [
		"default",
		"./ApiToken",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationModelConfigRemote/ApiToken": [
		"default",
		"./ApiToken",
		"webpack/container/reference/ApplicationModelConfigRemote"
	],
	"webpack/container/remote/ApplicationProjectsRemote/ApiToken": [
		"default",
		"./ApiToken",
		"webpack/container/reference/ApplicationProjectsRemote"
	],
	"webpack/container/remote/ApplicationReportRemote/ApiToken": [
		"default",
		"./ApiToken",
		"webpack/container/reference/ApplicationReportRemote"
	],
	"webpack/container/remote/StyleManagementRemote/StyleLoader": [
		"default",
		"./StyleLoader",
		"webpack/container/reference/StyleManagementRemote"
	],
	"webpack/container/remote/StyleManagementRemote/StyleSelect": [
		"default",
		"./StyleSelect",
		"webpack/container/reference/StyleManagementRemote"
	],
	"webpack/container/remote/ApplicationFrameRemote/ConfigData": [
		"default",
		"./ConfigData",
		"webpack/container/reference/ApplicationFrameRemote"
	],
	"webpack/container/remote/ApplicationFrameRemote/Menu": [
		"default",
		"./Menu",
		"webpack/container/reference/ApplicationFrameRemote"
	],
	"webpack/container/remote/ApplicationFrameRemote/AccessSignInButton": [
		"default",
		"./AccessSignInButton",
		"webpack/container/reference/ApplicationFrameRemote"
	],
	"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorDataset": [
		"default",
		"./ScenarioEditorDataset",
		"webpack/container/reference/ApplicationDatasetRemote"
	],
	"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorGeodata": [
		"default",
		"./ScenarioEditorGeodata",
		"webpack/container/reference/ApplicationDatasetRemote"
	],
	"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorHoT": [
		"default",
		"./ScenarioEditorHoT",
		"webpack/container/reference/ApplicationDatasetRemote"
	],
	"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorLabels": [
		"default",
		"./ScenarioEditorLabels",
		"webpack/container/reference/ApplicationDatasetRemote"
	],
	"webpack/container/remote/ApplicationMapRemote/ScenarioEditorMap": [
		"default",
		"./ScenarioEditorMap",
		"webpack/container/reference/ApplicationMapRemote"
	],
	"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorSpecification": [
		"default",
		"./ScenarioEditorSpecification",
		"webpack/container/reference/ApplicationDatasetRemote"
	],
	"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorToolbar": [
		"default",
		"./ScenarioEditorToolbar",
		"webpack/container/reference/ApplicationDatasetRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/DataExperiment": [
		"default",
		"./DataExperiment",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationModelConfigRemote/DataScenario": [
		"default",
		"./DataScenario",
		"webpack/container/reference/ApplicationModelConfigRemote"
	],
	"webpack/container/remote/ApplicationProjectsRemote/DataProjectList": [
		"default",
		"./DataProjectList",
		"webpack/container/reference/ApplicationProjectsRemote"
	],
	"webpack/container/remote/ApplicationModelConfigRemote/ScenarioList": [
		"default",
		"./ScenarioList",
		"webpack/container/reference/ApplicationModelConfigRemote"
	],
	"webpack/container/remote/ApplicationProjectsRemote/ProjectSelector": [
		"default",
		"./ProjectSelector",
		"webpack/container/reference/ApplicationProjectsRemote"
	],
	"webpack/container/remote/ApplicationProjectsRemote/DataProject": [
		"default",
		"./DataProject",
		"webpack/container/reference/ApplicationProjectsRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/ExperimentFactory": [
		"default",
		"./ExperimentFactory",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationDatasetRemote/ScenarioEditorForm": [
		"default",
		"./ScenarioEditorForm",
		"webpack/container/reference/ApplicationDatasetRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/EventNotifier": [
		"default",
		"./EventNotifier",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/ExperimentStatusDetail": [
		"default",
		"./ExperimentStatusDetail",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationModelConfigRemote/ScenarioHooks": [
		"default",
		"./ScenarioHooks",
		"webpack/container/reference/ApplicationModelConfigRemote"
	],
	"webpack/container/remote/ApplicationProjectsRemote/ProjectFactory": [
		"default",
		"./ProjectFactory",
		"webpack/container/reference/ApplicationProjectsRemote"
	],
	"webpack/container/remote/ApplicationReportRemote/ReportHooks": [
		"default",
		"./ReportHooks",
		"webpack/container/reference/ApplicationReportRemote"
	],
	"webpack/container/remote/ApplicationReportRemote/ReportView": [
		"default",
		"./ReportView",
		"webpack/container/reference/ApplicationReportRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/ExperimentsView": [
		"default",
		"./ExperimentsView",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationModelConfigRemote/ScenarioForm": [
		"default",
		"./ScenarioForm",
		"webpack/container/reference/ApplicationModelConfigRemote"
	],
	"webpack/container/remote/ApplicationModelConfigRemote/DataScenarioContexts": [
		"default",
		"./DataScenarioContexts",
		"webpack/container/reference/ApplicationModelConfigRemote"
	],
	"webpack/container/remote/ApplicationProjectsRemote/ProjectList": [
		"default",
		"./ProjectList",
		"webpack/container/reference/ApplicationProjectsRemote"
	],
	"webpack/container/remote/ApplicationProjectsRemote/ProjectForm": [
		"default",
		"./ProjectForm",
		"webpack/container/reference/ApplicationProjectsRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/ExperimentProgressBar": [
		"default",
		"./ExperimentProgressBar",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/ExperimentStartControl": [
		"default",
		"./ExperimentStartControl",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationJobsRemote/ExperimentStopControl": [
		"default",
		"./ExperimentStopControl",
		"webpack/container/reference/ApplicationJobsRemote"
	],
	"webpack/container/remote/ApplicationProjectsRemote/ProjectTagSettings": [
		"default",
		"./ProjectTagSettings",
		"webpack/container/reference/ApplicationProjectsRemote"
	],
	"webpack/container/remote/ApplicationModelConfigRemote/ScenarioTagSettings": [
		"default",
		"./ScenarioTagSettings",
		"webpack/container/reference/ApplicationModelConfigRemote"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}